import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { DocumentTypeService } from '../proxy/controlling/controllers/document-type.service';
import { ActivityService } from '../proxy/controlling/controllers/activity.service';

FieldBuilder.setNamespace('Controlling');

export const DOCUMENTTYPEPERACTIVITY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('documentTypeId', 'Entity.DocumentType', DocumentTypeService)
    .required()
    .displayFromNested('documentType.name')
    .sortBy('documentType.name')
    .build(),
  FieldBuilder
    .foreignKey('activityId', 'Entity.Activity', ActivityService)
    .required()
    .displayFromNested('activity.name')
    .sortBy('activity.name')
    .hideInChildForms()
    .build(),
];

export const DOCUMENTTYPEPERACTIVITY_CONFIG = {
  entityName: 'DocumentTypePerActivity',
  localizationKey: 'Controlling::Entity.DocumentTypePerActivity',
  fields: DOCUMENTTYPEPERACTIVITY_FIELDS,
  permission: 'ControllingActivities.DocumentTypePerActivities',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
